import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import Shell from "../components/dash/Shell";
import AdminBookings from "../components/admin/AdminBookings";
import AdminTechnicians from "../components/admin/AdminTechnicians";
import AdminCoupons from "../components/admin/AdminCoupons";
import AdminServices from "../components/admin/AdminServices";
import AdminGallery from "../components/admin/AdminGallery";
import AdminAI from "../components/admin/AdminAI";

const TABS = [
  ["bookings", "Bookings"],
  ["technicians", "Technicians"],
  ["coupons", "Coupons"],
  ["services", "Services"],
  ["gallery", "Gallery"],
  ["ai", "AI Summary"],
];

const Stat = ({ label, value, testid }) => (
  <div data-testid={testid} className="rounded-2xl border border-white/10 bg-panel/70 px-5 py-4">
    <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-400">{label}</p>
    <p className="font-display font-extrabold text-2xl text-white mt-1">{value}</p>
  </div>
);

export default function AdminDashboard() {
  const [tab, setTab] = useState("bookings");
  const [stats, setStats] = useState(null);

  const loadStats = () => api.get("/admin/stats").then(({ data }) => setStats(data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { loadStats(); }, [tab]);

  return (
    <Shell title="Admin panel">
      {stats && (
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-3">
          <Stat testid="stat-bookings" label="Bookings" value={stats.bookings} />
          <Stat testid="stat-pending" label="Pending" value={stats.pending} />
          <Stat testid="stat-revenue" label="Paid online" value={`₹${stats.revenue}`} />
          <Stat testid="stat-technicians" label="Technicians" value={stats.technicians} />
          <Stat testid="stat-approvals" label="To approve" value={stats.pending_approvals} />
          <Stat testid="stat-subs" label="Sub requests" value={stats.pending_subscriptions} />
          <Stat testid="stat-coupons" label="Live coupons" value={stats.coupons} />
        </div>
      )}

      <div className="flex flex-wrap gap-2 mt-8 border-b border-white/10 pb-4">
        {TABS.map(([id, label]) => (
          <button
            key={id}
            data-testid={`admin-tab-${id}`}
            onClick={() => setTab(id)}
            className={`rounded-full px-4 py-2 font-mono text-[11px] uppercase tracking-[0.18em] transition-colors ${tab === id ? "bg-gold text-ink" : "border border-white/15 text-slate-300 hover:border-gold hover:text-gold"}`}
          >
            {label}
          </button>
        ))}
      </div>

      <div className="mt-6">
        {tab === "bookings" && <AdminBookings onChange={loadStats} />}
        {tab === "technicians" && <AdminTechnicians onChange={loadStats} />}
        {tab === "coupons" && <AdminCoupons onChange={loadStats} />}
        {tab === "services" && <AdminServices />}
        {tab === "gallery" && <AdminGallery />}
        {tab === "ai" && <AdminAI />}
      </div>
    </Shell>
  );
}
